import { createContext, useContext } from "react";

import { TariffState } from "features/Tariff/types";

export const TariffContext = createContext<TariffState | null>(null);

export const useTariffContext = (): TariffState => {
    const state = useContext(TariffContext);

    if (!state) {
        throw new Error("useTariffContext должен использоваться внутри Tariff");
    }

    return state;
};
